export default {
  loading_menu: 'Indlæser menu...',
};
